import React, { Dispatch, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { handleChangeInput } from '@app/helpers';
import { MethodsMfa } from '@app/enums';
import { ActiveMethodManageMfa } from '@app/models';
import Icon from '@app/components/Icon/index';
import { RadioButton } from '@itglue/kaseya-ui';

export interface IChooseMethod {
    isOnboarding?: boolean;
    isMfaConfigured: boolean;
    activeMethod: ActiveMethodManageMfa;
    setActiveMethod: Dispatch<ActiveMethodManageMfa>;
}

export const ChooseMethod: React.SFC<IChooseMethod> = ({ isOnboarding, isMfaConfigured, activeMethod, setActiveMethod }) => {
    const { translation } = useTypedTranslation();
    const isMfaAlreadyConfigured = isMfaConfigured && activeMethod && activeMethod !== MethodsMfa.u2f;

    useEffect(() => {
        setActiveMethod(''); // on load of dialog, clear the active method since it might have been set previously
    }, []);

    return (
        <>
            <Icon icon='chooseMethodIco' className='manage-mfa-token__choose-method-icon' />
            {!isMfaAlreadyConfigured && <h1 className='manage-mfa-token__title'>{translation('SET_UP_MFA_HEADER')}</h1>}
            {isMfaAlreadyConfigured && (
                <>
                    <div className='manage-mfa-token__warning'>{translation('MFA_ALREADY_CONFIGURED_WARNING_HEADER')}</div>
                    <div className='manage-mfa-token__warning'>{translation('MFA_ALREADY_CONFIGURED_WARNING')}</div>
                </>
            )}
            <div className='manage-mfa-token__description'>{translation('SET_UP_MFA_DESCRIPTION')}</div>
            <div className='manage-mfa-token__radio-group-block'>
                <div className='manage-mfa-token__radio-group-subtitle'>{translation('SET_UP_MFA_SUBTITLE')}</div>
                <RadioButton
                    value={MethodsMfa.iPhone}
                    label={translation('PHONE_IPHONE')}
                    name='method'
                    checked={activeMethod === MethodsMfa.iPhone}
                    onChange={handleChangeInput(setActiveMethod)}
                />
                <RadioButton
                    value={MethodsMfa.android}
                    label={translation('PHONE_ANDROID')}
                    name='method'
                    checked={activeMethod === MethodsMfa.android}
                    onChange={handleChangeInput(setActiveMethod)}
                />
                <RadioButton
                    value={MethodsMfa.yubikey}
                    label={`${translation('YUBIKEY_HOTP')} (${translation('REQUIRES_YUBIKEY_PROGRAMMER')})`}
                    name='method'
                    checked={activeMethod === MethodsMfa.yubikey}
                    onChange={handleChangeInput(setActiveMethod)}
                />
                <RadioButton
                    value={MethodsMfa.u2f}
                    label={translation('U2F_DEVICE')}
                    name='method'
                    checked={activeMethod === MethodsMfa.u2f}
                    onChange={handleChangeInput(setActiveMethod)}
                />
            </div>
        </>
    );
};
